module.exports = __webpack_public_path__ + "static/media/st_summary.057a3c2f.pdf";